module.exports = __webpack_public_path__ + "static/media/pause.ea3eda16.svg";